import { SVGAttributes } from 'react';

const Fund = (props: SVGAttributes<SVGElement>) => (
    <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
        <path
            d="M7.178 23 1 30.285l5.71 1.102L8.994 38 15 28.804M32.822 23 39 30.285l-5.71 1.102L31.006 38 25 28.804"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20 29c7.732 0 14-6.268 14-14S27.732 1 20 1 6 7.268 6 15s6.268 14 14 14Z"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M23 20.6c-.675.265-1.4.4-2.132.4-1.625-.067-3.155-.737-4.254-1.862-1.1-1.125-1.678-2.613-1.608-4.138-.07-1.525.509-3.013 1.608-4.138 1.099-1.125 2.63-1.794 4.254-1.862a6.24 6.24 0 0 1 1.748.26M13 13h6M13 17h6"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Fund;
